<div class="text-center py-3" *ngIf="tags_loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!tags_loading">
  <div class="row">
    <div class="col-10 offset-1">
      <a href="javascript: void(0)" class="btn btn-link btn-sm" (click)="showNewTagForm = !showNewTagForm"> <i [class]="'fa fa-' + (showNewTagForm ? 'minus' : 'plus') + '-circle'"></i>&nbsp;New Tag </a>
      <div *ngIf="showNewTagForm">
        <div class="form-group row ml-3 mt-3">
          <label class="col-2 col-form-label">Tag</label>
          <div class="col-10">
            <input type="text" class="form-control" required name="newTag" [(ngModel)]="newTag" />
          </div>
        </div>
        <div class="form-group text-center">
          <button type="button" class="btn btn-sm btn-primary" (click)="addTag()">Add</button>
          &nbsp;
          <button type="button" class="btn btn-sm btn-secondary" (click)="showNewTagForm = false">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-10 offset-1">
      <table class="table" style="font-size: 90%">
        <tbody>
          <tr *ngFor="let tag of tags; let i = index">
            <td>
              <a class="pull-right float-right text-danger" href="javascript: void(0)" (click)="removeTag(i)"><i class="fas fa-times"></i></a>
              {{ tag }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
